import { render, staticRenderFns } from "./del-case-batch-number.vue?vue&type=template&id=023bcfd9&scoped=true"
import script from "./del-case-batch-number.vue?vue&type=script&lang=ts"
export * from "./del-case-batch-number.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bcfd9",
  null
  
)

export default component.exports